'use client';

import React from 'react';

import { CardReview } from '@/components/CardReview';
import { Media } from '@/components/Media';
import type { Review, ReviewPlatform } from '@/payload-types';

export const ReviewList: React.FC<{
  reviews: Review[];
  platformsTitle: string;
  platformsDescription: string;
  platforms: ReviewPlatform[];
}> = ({ reviews, platformsTitle, platformsDescription, platforms }) => {
  const objectReviews = reviews.filter((i) => typeof i === 'object');

  return (
    <section className="v-margin !mt-0" data-name="ReviewList">
      <div className="container">
        <div className="grid grid-cols-2 gap-5 md:grid-cols-1 md:gap-3">
          {objectReviews?.map((doc, index) => {
            if (typeof doc === 'object' && doc !== null) {
              return <CardReview doc={doc} key={index} />;
            }

            return null;
          })}
        </div>

        {/* Platforms  */}
        <div className="v-margin !mb-0">
          <h2 className="h2 mx-auto mb-5 max-w-[820px] text-center md:mb-4">
            {platformsTitle}
          </h2>

          <div className="mb-12 text-center md:mb-6">
            {platformsDescription}
          </div>

          {platforms && platforms.length > 0 && (
            <div className="mx-auto grid max-w-[1026px] grid-cols-2 gap-x-8 gap-y-12 md:gap-x-5 md:gap-y-6">
              {platforms.map((i) => (
                <Media imgClassName="mx-auto" resource={i.logo} key={i.id} />
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
